<template>
  <transition name="fade">
    <search-template :show="show_filter || !is_mobile" @closeFilter="show_filter = false">
      <template v-slot:top-search>
        <auto-complete @triggerKeywordSearch="searchKeywordsDebounce" :keywords="keywords" :openSearch="openSearch" @triggerSearchSelect="searchWithKeywords" />
      </template>
      <template v-slot:filter-header>
        <ClearFilterLink :clearFilter="clearFilter" :filters="filters.current" :showMobileFilter="showMobileFilter" :is_mobile="is_mobile" />
        <current-filters :filters="[...filters.current]" @removeFilter="removeFilter" />
      </template>
      <template v-slot:filter-container>
        <div class="filter-head" v-if="is_mobile">
          <ClearFilterLink :clearFilter="clearFilter" :filters="filters.current" />
          <current-filters :filters="[...filters.current]" @removeFilter="removeFilter" />
        </div>
        <app-accordion>
          <template v-slot:title>
            Location
          </template>
          <template v-slot:content>
            <GMapAutocomplete placeholder="Address, City, State or ZIP" :componentRestrictions="{ country: ['us'] }" @place_changed="setPlace" />
            <i class="fa-solid fa-magnifying-glass location-search-icon"></i>
          </template>
        </app-accordion>

        <app-accordion v-if="'sud' === type">
          <template v-slot:title>
            Treatment
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for="   treatment    in    treatments   " :data="treatment" :value="`${treatment.adult_id}-${treatment.adolescent_id}`" :label="treatment.name" :key="treatment.id" :is_active="[...filters.current]" @onTriggeredClicked="changeFilter" :type="'treatment'">
              </checkbox>
            </div>
          </template>
        </app-accordion>

        <app-accordion v-if="'eap' === type">
          <template v-slot:title>
            Specialty
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for="   speciality    in eap.specialties   " :data="speciality" :value="`${speciality.id}`" :label="speciality.name" :key="speciality.id" :is_active="[...filters.current]" @onTriggeredClicked="changeFilter" :type="'speciality'">
              </checkbox>
            </div>
          </template>

        </app-accordion>

        <app-accordion class="mb-8" v-if="'sud' === type">
          <template v-slot:title>
            Recovery Support Services (RSS)
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for="rs in rss" :data="rs" :value="`${rs.adult_id}-${rs.adolescent_id}`" :label="rs.name" :key="rs.id" :is_active="[...filters.current]" @onTriggeredClicked="changeFilter" :type="'rss'">
              </checkbox>
            </div>
          </template>
        </app-accordion>

        <app-accordion class="mb-8">
          <template v-slot:title>
            Age(s)
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for="age in ages" :data="age" :value="age.term_id" :label="age.name" :is_active="[...filters.current]" :key="age.term_id" :type="'ages'" @onTriggeredClicked="changeFilter">
              </checkbox>
            </div>
          </template>
        </app-accordion>

        <app-accordion class="mb-8" v-if="'eap' === type">
          <template v-slot:title>
            Provider Availability
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for="provider_availabily in eap.provider_availabilities" :data="provider_availabily" :value="provider_availabily.term_id" :label="provider_availabily.name" :is_active="[...filters.current]" :key="provider_availabily.term_id" :type="'provider_availabily'" @onTriggeredClicked="changeFilter">
              </checkbox>
            </div>
          </template>
        </app-accordion>

        <app-accordion class="mb-8">
          <template v-slot:title>
            Hours
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for="   hr    in    hrs   " :data="hr" :value="hr.term_id" :label="hr.name" :is_active="[...filters.current]" :key="hr.term_id" :type="'hrs'" @onTriggeredClicked="changeFilter">
              </checkbox>
            </div>
          </template>
        </app-accordion>
        <app-accordion class="mb-8" v-if="'eap' === type">
          <template v-slot:title>
            Provider Gender
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for=" gender  in  genders " :data="gender" :is_active="[...filters.current]" :key="gender.term_id" :type="'genders'" @onTriggeredClicked="changeFilter">
              </checkbox>
            </div>
          </template>
        </app-accordion>
        <app-accordion class="mb-8" v-if="'sud' === type">
          <template v-slot:title>
            Funding Sources
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for=" funding_source  in  funding_sources " :data="funding_source" :is_active="[...filters.current]" :key="funding_source.term_id" :type="'funding_sources'" @onTriggeredClicked="changeFilter">
              </checkbox>
            </div>
          </template>
        </app-accordion>
        <app-accordion class="mb-8">
          <template v-slot:title>
            Language
          </template>
          <template v-slot:content>
            <div class="checkbox-container">
              <checkbox v-for="language in languages" :data="language" :is_active="[...filters.current]" :key="language.term_id" :type="'languages'" @onTriggeredClicked="changeFilter">
              </checkbox>
            </div>
          </template>
        </app-accordion>
      </template>
      <template v-slot:search-container>
        <div class="resource-container" id="id_resources">
          <AuthenticationRequired v-if="'eap' === type" :theme="'dark'" />
          <provider-card v-for="provider in providers" :data="provider" :type="type" v-if="providers.length" @openModal="openModal"></provider-card>
          <div class="no-result" v-else>No Provider found</div>
        </div>

        <paginate :page-range="3" :page-count="total_pages" v-if="showPagination" :click-handler="nextPage" :prev-class="'prev-items fa-solid fa-chevron-left fa-lg'" :prev-text="''" :next-class="'next-items fa-solid fa-chevron-right fa-lg'" :next-text="''" :container-class="'pagination'">
        </paginate>
      </template>
    </search-template>
  </transition>
  <Modal :active="isModalVisible" :closeModal="closeModal">
    <template v-slot:modal-body>
      <ContactInformationForm :provider="provider_info" />
    </template>
  </Modal>
</template>

<script>
import Modal from "./components/Modal.vue"
import axios from "axios"
import SearchTemplate from './SearchTemplate.vue'
import AppAccordion from './components/AppAccordion.vue'
import Checkbox from './components/Checkbox.vue'
import ProviderCard from './components/ProviderCard.vue'
import Paginate from "vuejs-paginate-next"
import AutoComplete from "./components/AutoComplete.vue"
import CurrentFilters from './components/CurrentFilters.vue'
import AuthenticationRequired from './components/AuthenticationRequired.vue'
import ClearFilterLink from './components/ClearFilterLink.vue'
import ContactInformationForm from './components/ContactInformationForm.vue'
import { debounce } from "lodash"

export default {
  props: {
    filterlists: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      openSearch: false,
      type: 'sud',
      treatments: [],
      eap: {
        specialties: [],
        provider_availabilities: [],
      },
      rss: [],
      ages: [],
      hrs: [],
      genders: [],
      funding_sources: [],
      languages: [],
      isModalVisible: false,
      provider_info: {},
      filters: {
        treatments: new Set,
        specialties: new Set,
        provider_availabilities: new Set,
        rss: new Set,
        hrs: new Set,
        ages: new Set,
        current: new Set,
        genders: new Set,
        funding_sources: new Set,
        languages: new Set,
        keyword: '',
        address: {
          lat: '',
          lng: '',
          state: ''
        }
      },
      items_per_page: 1,
      current_page: 1,
      total_pages: 0,
      request_page: 1,
      total_resources: 0,
      showPagination: false,
      providers: [],
      keywords: [],
      show_filter: false,
      is_mobile: false
    }
  },
  components: { ContactInformationForm, AppAccordion, Checkbox, ProviderCard, Paginate, AutoComplete, CurrentFilters, SearchTemplate, AuthenticationRequired, ClearFilterLink, Modal },
  created () {
    const filters = JSON.parse( this.$props.filterlists )

    this.treatments = filters.treatments
    this.eap.specialties = filters.specialties
    this.eap.provider_availabilities = filters.provider_availabilities
    this.rss = filters.rss
    this.hrs = filters.hrs
    this.ages = filters.ages
    this.genders = filters.genders
    this.funding_sources = filters.funding_sources
    this.languages = filters.languages
    this.type = filters.type

    this.checkIfMobile()
  },
  mounted () {
    this.updateURLFilters()
    this.fetch()
    window.addEventListener( "resize", this.checkIfMobile.bind( this ) )

  },
  methods: {
    checkIfMobile () {
      if ( window.innerWidth <= 1200 ) {
        this.is_mobile = true
      } else {
        this.is_mobile = false
        this.show_filter = true
      }
    },
    showMobileFilter () {
      this.show_filter = !this.show_filter
    },
    openModal ( provider ) {
      this.provider_info = provider
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
    updateURLFilters () {
      const queryString = window.location.search
      const urlParams = new URLSearchParams( queryString )

      const paged = urlParams.get( 'paged' )

      const treatments = urlParams.get( 'treatments' )
      const specialties = urlParams.get( 'specialties' )
      const rss = urlParams.get( 'rss' )
      const hrs = urlParams.get( 'hrs' )
      const ages = urlParams.get( 'ages' )
      const genders = urlParams.get( 'genders' )
      const funding_sources = urlParams.get( 'funding_sources' )
      const languages = urlParams.get( 'languages' )
      const keyword = urlParams.get( 'keyword' )
      const provider_availabilities = urlParams.get( 'provider_availabilities' )

      if ( paged ) {
        this.request_page = paged
      }

      if ( treatments ) {
        this.filters.treatments = new Set( treatments?.split( ',' ) )

        this.filters.treatments.forEach( element => {
          this.treatments.map( treatment => {
            const term_id = `${ treatment.adult_id }-${ treatment.adolescent_id }`

            if ( element === term_id ) {
              treatment.term_id = term_id
              treatment.checked = true
              this.updateCurrentFilter( treatment )
            }
          } )
        } )
      }

      if ( specialties ) {
        this.filters.specialties = new Set( specialties?.split( ',' ).map( String ) )

        this.filters.specialties.forEach( element => {

          this.eap.specialties.map( speciality => {
            console.log(speciality.id)
            if ( element === speciality.id ) {
              speciality.term_id = speciality.id
              speciality.checked = true
              this.updateCurrentFilter( speciality )
            }
          } )
        } )
      }

      if ( provider_availabilities ) {
        this.filters.provider_availabilities = new Set( provider_availabilities?.split( ',' ).map( String ) )

        this.filters.provider_availabilities.forEach( element => {

          this.eap.provider_availabilities.map( provider_availablity => {

            if ( element === provider_availablity.term_id ) {
              provider_availablity.checked = true
              this.updateCurrentFilter( provider_availablity )
            }
          } )
        } )
      }

      if ( rss ) {
        this.filters.rss = new Set( rss?.split( ',' ) )

        this.filters.rss.forEach( element => {
          this.rss.map( rs => {
            const term_id = `${ rs.adult_id }-${ rs.adolescent_id }`

            if ( element === term_id ) {
              rs.term_id = term_id
              rs.checked = true
              this.updateCurrentFilter( rs )
            }
          } )
        } )
      }

      if ( funding_sources ) {
        this.filters.funding_sources = new Set( funding_sources?.split( ',' ) )

        this.filters.funding_sources.forEach( element => {
          this.funding_sources.map( funding_source => {

            if ( element === funding_source.term_id ) {
              funding_source.checked = true
              this.updateCurrentFilter( funding_source )
            }
          } )
        } )
      }

      if ( hrs ) {
        this.filters.hrs = new Set( hrs?.split( ',' ).map( String ) )

        this.filters.hrs.forEach( element => {
          this.hrs.map( hr => {
            if ( element === hr.term_id ) {
              hr.checked = true
              this.updateCurrentFilter( hr )
            }
          } )
        } )
      }

      if ( ages ) {
        this.filters.ages = new Set( ages?.split( ',' ).map( String ) )

        this.filters.ages.forEach( element => {
          this.ages.map( age => {
            if ( element === age.term_id ) {
              age.checked = true
              this.updateCurrentFilter( age )
            }
          } )
        } )
      }

      if ( genders ) {
        this.filters.genders = new Set( genders?.split( ',' ).map( String ) )

        this.filters.genders.forEach( element => {
          this.genders.map( gender => {
            if ( element === gender.term_id ) {
              gender.checked = true
              this.updateCurrentFilter( gender )
            }
          } )
        } )
      }

      if ( languages ) {
        this.filters.languages = new Set( languages?.split( ',' ).map( String ) )

        this.filters.languages.forEach( element => {
          this.languages.map( language => {
            if ( element === language.term_id ) {
              language.checked = true
              this.updateCurrentFilter( language )
            }
          } )
        } )
      }

      if ( keyword ) {
        this.filters.keyword = keyword
      }
    },
    changeFilter ( data ) {
      data.checked ? this.filters[ data.taxonomy ].add( data.term_id ) : this.filters[ data.taxonomy ].delete( data.term_id )
      this.updateCurrentFilter( data )
      this.request_page = 1
      this.showPagination = false

      this.fetch()
    },
    fetch: debounce( function () {
      this.fetchData()
    }, 500 ),
    nextPage ( page ) {
      document.getElementById( 'id_resources' ).scrollIntoView( {
        behavior: 'smooth'
      } )

      this.request_page = page
      this.fetch()
    },
    updateCurrentFilter ( data ) {
      data.checked ? this.filters.current.add( data ) : this.filters.current.delete( data )
    },
    removeFilter ( filter ) {
      this.filters.current.forEach( element => {

        if ( this.filters[ element.taxonomy ].has( filter.term_id ) ) {
          this.filters[ element.taxonomy ].delete( filter.term_id )
        }
      } )

      this.filters.current.delete( filter )

      this.fetch()
    },
    async fetchData () {

      const params = {
        treatments: [ ...this.filters.treatments ],
        rss: [ ...this.filters.rss ],
        hrs: [ ...this.filters.hrs ],
        ages: [ ...this.filters.ages ],
        genders: [ ...this.filters.genders ],
        funding_sources: [ ...this.filters.funding_sources ],
        languages: [ ...this.filters.languages ],
        specialties: [ ...this.filters.specialties ],
        provider_availabilities: [ ...this.filters.provider_availabilities ],
        keyword: this.filters[ 'keyword' ]
      }

      const res = await axios.get( `/wp-json/bpa/v1/providers`, {
        params: Object.assign( {}, params, {
          paged: this.request_page,
          type: this.type,
          address: this.filters.address,
          keyword: this.filters.keyword,
        } )
      } )

      this.current_page = res.current_page
      this.total_pages = res.total_pages
      this.total = res.total_resources
      this.items_per_page = res.items_per_page
      this.providers = res.data

      this.showPagination = this.items_per_page > this.total ? false : true

      let new_params = {}

      Object.keys( params ).forEach( ( key ) => {
        if ( ( ( typeof params[ key ] === 'string' || typeof params[ key ] === 'number' ) && params[ key ] ) || ( Array.isArray( params[ key ] ) && params[ key ].length ) ) {
          new_params[ key ] = params[ key ]
        }
      } )

      new_params ? history.pushState(
        {},
        null,
        window.location.href.split( '?' )[ 0 ] + '?' + new URLSearchParams( new_params ).toString()
      ) : ''
    },

    clearFilter () {
      this.filters = {
        treatments: new Set,
        specialties: new Set,
        provider_availabilities: new Set,
        rss: new Set,
        hrs: new Set,
        ages: new Set,
        current: new Set,
        genders: new Set,
        funding_sources: new Set,
        languages: new Set,
        keyword: '',
        address: {
          lat: '',
          lng: '',
          state: ''
        }
      }

      this.fetch()
    },
    searchKeywordsDebounce: debounce( function ( keyword ) {
      this.searchKeywords( keyword )
    }, 500 ),
    async searchKeywords ( keyword ) {
      this.openSearch = true

      const res = await axios.get( `/wp-json/bpa/v1/providers/keywords`, {
        params: {
          keyword: keyword,
          type: this.type
        }
      } )

      this.keywords = res.data
      this.openSearch = false
    },

    searchWithKeywords ( keyword ) {
      this.filters.keyword = keyword
      this.fetch()
    },

    setPlace ( places ) {
      this.filters.address.lat = places.geometry.location.lat()
      this.filters.address.lng = places.geometry.location.lng()
      this.filters.address.state = ''

      if ( places?.types?.includes( "administrative_area_level_1" ) ) {
        this.filters.address.state = places.address_components[ 0 ]?.short_name
      }

      this.fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/variables";
@import "../sass/mixins";

.checkbox-container {
  display: grid;
  gap: 8px;
}

.resource-container {
  display: grid;
  gap: 20px;
}

.filter-head {
  position: relative;
  margin-bottom: 24px;

  &::after {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: $colors-secondary;
    content: "";
  }
}

input {
  width: 100%;
  border: none;
  background-color: #F5F5F5;
  height: 50px;
  border-radius: 25px;
  padding-left: 25px;
  padding-right: 50px;

  &::placeholder {
    font-weight: 500;
    font-family: Paralucent;
    color: #B7B7B7;
    font-size: 14px;
  }
}

.location-search-icon {
  position: absolute;
  top: 16.5px;
  right: 20px;
}
</style>